// src/utils/EnumsUtils.js
// Centraliza enums e constantes globais reutilizáveis

export const Lados = {
  NENHUM: 'nenhum',
  ESQUERDA: 'esquerda',
  DIREITA: 'direita',
  AMBOS: 'ambos'
};

export const FuncionalidadesAdicionais = {
  RECALCULO_AUTOMATICO: 'Recálculo Automático',
  MAPRA_EQUIPAMENTOS: 'Mapa Equipamentos',
}

export const EnumSistemas = {
  DIXI_PONTO: 'Ponto',
  // DIXI_CHAMADOS: 'Chamado',
  DIXI_ACESSOS: 'Acesso',
};

// Adicione outros enums ou constantes globais aqui conforme necessário
